const util = {
    getUploaderInfo: () => {
        const uploaderUrl = `${process.env.VUE_APP_API_ENDPOINT}/api/admin/uploads/gcs`;
        const accessToken = localStorage.getItem('accessToken');
        return {
            url: uploaderUrl,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
    },
    queryToString: query => {
        let queryStr = '';
        let keys = Object.keys(query);
        for (let index = 0; index < keys.length; index++) {
            const element = keys[index];
            let key = element;
            let value = query[key];
            if (element.startsWith('findBy')) {
                key = 'findBy[]';
                value = query[element];
            }
            if (element.startsWith('filterBy')) {
                key = 'filterBy[]';
                value = query[element];
            }
            if (element.startsWith('orValue')) {
                key = 'orValue[]';
                value = query[element];
            }

            if (index === 0) {
                queryStr = `${key}=${value}&`;
            } else if (index === keys.length - 1) {
                queryStr = `${queryStr}${key}=${value}`;
            } else {
                queryStr = `${queryStr}${key}=${value}&`;
            }
        }
        return queryStr;
    },
    checkPermission: (required = [], resources = []) => {
        if (typeof required === 'string') {
            required = [required];
        }
        let resourceMap = resources.map(
            n => `${n.AdminResource.name}:${n.AdminResource.actionType}`
        );
        let isAllowed = true;
        for (let index = 0; index < required.length; index++) {
            const element = required[index];
            if (!resourceMap.includes(element)) {
                isAllowed = false;
                break;
            }
        }
        return isAllowed;
    }
};

export default util;
